<key-leaflet-map class="flex-1 position-relative"
    #map
    [loading]="!this.telemetry"></key-leaflet-map>